import { render } from "./AssistantListPage.vue?vue&type=template&id=07bc4e12"
import script from "./AssistantListPage.vue?vue&type=script&lang=js"
export * from "./AssistantListPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__